import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
  TextField,
  Button,
  Avatar,
} from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import { Plus } from "lucide-react";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import graphqlRequest from "../../../requestMethod";

export default function AcceptApplicationDialog({
  open,
  onClose,
  onConfirm,
  //   applicant = {
  //     id: id,
  //     name: "Dr. Manjeet Kumar",
  //     degree: "MBBS",
  //     designation: "Resident Medical Officer",
  //     avatar: "", // image URL
  //   },
  applicant,
  defaultPoc,
}) {
  console.log("applicantData", applicant);
  let dyPoc = `${defaultPoc?.contactPerson}- ${defaultPoc?.email}`;
  const [isEditing, setIsEditing] = useState(false);
  const [poc, setPoc] = useState(dyPoc);
  const [fetchContactDetails, setFetchContactDetails] = useState([]);
  const [selectOpen, setSelectOpen] = useState(false);
  const [showAddPocForm, setShowAddPocForm] = useState(false);
  const [newPoc, setNewPoc] = useState({ name: "", email: "", phone: "" });
  const [errorMsg, setErrorMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState("");
  

  const handleEditClick = () => setIsEditing(true);
  // const handleConfirm = () => {
  //   setIsEditing(true);
  //   onConfirm(poc);
  // };

  const handleConfirm = async () => {
    setIsEditing(true);
    console.log("pocData", poc);
    if (poc) {
      await handlePocUpdate(); 
    }

    onConfirm(poc); 
  };

  let loginData = localStorage.getItem("auth");
  let token = JSON.parse(loginData)?.accessToken;

  function fetchContactDetailsUser() {
    const query = `
           query{
             withAuth(token:"${token}"){
               listOrganizationUsers {
                 id
                 email
                 contact
                 name 
               }
              }
            }
         `;
    graphqlRequest(query).then((response) => {
      // console.log("response", response.data.withAuth.listOrganizationUsers);
      setFetchContactDetails(response.data.withAuth.listOrganizationUsers);
    });
  }

  const handlePocCreate = async () => {
    const { name, email, phone } = newPoc;
    if (!name || !email || !phone) {
      setErrorMsg("All fields are required.");
      return;
    }

    setIsSubmitting(true);
    setErrorMsg("");

    const query = `
mutation {
  mutationWithAuth(token: "${token}") {
    update {
      updateApplicationViaAccept(id: "${applicant?.id}", data: {contactPerson: "${name}", email: "${email}", phone: "${phone}"})
    }
  }
}
        `;

    console.log("POC creation query:", query);
    try {
      const response = await graphqlRequest(query);
      console.log("POC creation response:", response);
      if (response?.data?.mutationWithAuth?.update?.updateApplicationViaAccept) {
        const pocDisplay = `${name} - ${email}`;
        const newPocEntry = { name, email, contact: phone };
        setFetchContactDetails((prev) => [...prev, newPocEntry])
        setPoc(pocDisplay);
        setNewPoc({ name: "", email: "", phone: "" });
        setShowAddPocForm(false);
      } else {
        setErrorMsg(response?.errors?.[0]?.message || "Error creating POC.");
      }
    } catch (err) {
      setErrorMsg("Failed to create POC.");
    } finally {
      setIsSubmitting(false);
    }
  };

   const handlePocUpdate = async () => {
     let selectedPOC;
     console.log("poc", poc);
     console.log("fetchContactDetails", fetchContactDetails);
     // Try finding selected POC from dropdown list
     const fromList = fetchContactDetails.find(
       (u) => `${u.name} - ${u.email}` === poc
     );

     if (fromList) {
       console.log("Using selected POC from list:", fromList);
       selectedPOC = {
         name: fromList.name,
         email: fromList.email,
         phone: fromList.contact, // assuming "contact" is phone number
       };
     } else  {
       console.log("Using default POC:", defaultPoc);
       // Fallback to default POC
       selectedPOC = {
         name: defaultPoc.contactPerson,
         email: defaultPoc.email,
         phone: defaultPoc.phone,
       };
     }
     console.log("Selected POC:", selectedPOC);
     // const { name, email, phone } = newPoc;
     if (!selectedPOC.name || !selectedPOC.email || !selectedPOC.phone) {
       setErrorMsg("All fields are required.");
       return;
     }
     // if (!name || !email || !phone) {
     //   setErrorMsg("All fields are required.");
     //   return;
     // }

     setIsSubmitting(true);
     setErrorMsg("");

     const query = `
mutation {
  mutationWithAuth(token: "${token}") {
    update {
      updateOnlyApplicationViaAccept(id: "${applicant?.id}", data: {contactPerson: "${selectedPOC?.name}", email: "${selectedPOC?.email}", phone: "${selectedPOC?.phone}"})
    }
  }
}
        `;

     console.log("POC creation query:", query);
     try {
       const response = await graphqlRequest(query);
       console.log("POC creation response:", response);
       if (
         response?.data?.mutationWithAuth?.update?.updateApplicationViaAccept
       ) {
         const pocDisplay = `${selectedPOC?.name} - ${selectedPOC?.email}`;
         const newPocEntry = {
           name: selectedPOC?.name,
           email: selectedPOC?.email,
           contact: selectedPOC?.phone,
         };
         setFetchContactDetails((prev) => [...prev, newPocEntry]);
         setPoc(pocDisplay);
         setNewPoc({ name: "", email: "", phone: "" });
         setShowAddPocForm(false);
       } else {
         setErrorMsg(response?.errors?.[0]?.message || "Error creating POC.");
       }
     } catch (err) {
       setErrorMsg("Failed to create POC.");
     } finally {
       setIsSubmitting(false);
     }
   };

  useEffect(() => {
    fetchContactDetailsUser();
  }, []);

  useEffect(() => {
    if (isEditing) {
      // Delay opening dropdown until after Select has rendered
      const timer = setTimeout(() => {
        setSelectOpen(true);
      }, 100); // 100ms delay is usually enough

      return () => clearTimeout(timer);
    }
  }, [isEditing]);

   const handleEmailChange = (e) => {
     const email = e.target.value;
     setNewPoc({ ...newPoc, email });

     // Simple email pattern
     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

     if (!emailPattern.test(email)) {
       setEmailError("Invalid email format");
     } else {
       setEmailError("");
     }
   };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">
            Are you sure you want to accept this application?
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 2,
              borderRadius: 2,
              backgroundColor: "#f9f9f9",
              mb: 3,
            }}
          >
            <Avatar
              src={applicant.avatar}
              alt={applicant.name}
              sx={{ width: 48, height: 48 }}
            />
            <Box>
              <Typography fontWeight={600}>{applicant.name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {applicant.degree} • {applicant.designation}
              </Typography>
            </Box>
          </Box>

          <Typography variant="subtitle2" gutterBottom>
            POC (Shift In-Charge)
          </Typography>
          <Box sx={{ position: "relative" }}>
            {isEditing ? (
              <Select
                fullWidth
                open={selectOpen}
                onOpen={() => setSelectOpen(true)}
                onClose={() => setSelectOpen(false)}
                value={poc}
                onChange={(e) => setPoc(e.target.value)}
                displayEmpty
                renderValue={(selected) => selected || "Select POC"}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflow: "auto",
                    },
                  },
                }}
                sx={{ mt: 1 }}
              >
                {/* Default POC on top */}
                {defaultPoc?.email && (
                  <MenuItem
                    value={`${defaultPoc.contactPerson} - ${defaultPoc.email}`}
                  >
                    {defaultPoc.contactPerson} - {defaultPoc.email}
                  </MenuItem>
                )}

                {/* Other fetched POCs, excluding default if already included */}
                {fetchContactDetails
                  ?.filter(
                    (user) =>
                      user.email !== defaultPoc?.email &&
                      `${user.name} - ${user.email}` !== poc
                  )
                  ?.map((user) => (
                    <MenuItem
                      key={user.id}
                      value={`${user.name} - ${user.email}`}
                    >
                      {user.name} - {user.email}
                    </MenuItem>
                  ))}

                <MenuItem
                  value={newPoc.name ? `${newPoc.name} - ${newPoc.email}` : ""}
                  onClick={() => {
                    setSelectOpen(false);
                    setShowAddPocForm(true);
                  }}
                  sx={{
                    border: "1px solid #cfe0f7",
                    backgroundColor: "#f4f8fd",
                    color: "#105049",
                    fontWeight: 600,
                    justifyContent: "center",
                    mt: 1,
                    mx: 1,
                    borderRadius: "12px",
                    "&:hover": {
                      backgroundColor: "#e6f0fb",
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    {/* <span style={{ fontSize: "18px" }}>+</span> */}
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      color="primary"
                    >
                      <Plus
                        size={16}
                        className="plus-icon"
                        style={{
                          marginBottom: "-1px",
                          gap: "4px",
                          marginRight: "4px",
                        }}
                      />
                      Add New POC (Shift In-Charge)
                    </Typography>
                  </Box>
                </MenuItem>
              </Select>
            ) : (
              <TextField
                fullWidth
                value={poc}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <IconButton onClick={handleEditClick}>
                      <EditIcon />
                    </IconButton>
                  ),
                }}
              />
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            // sx={{ backgroundColor: "#105049" }}
            sx={{
              backgroundColor: "#06468c",
              "&:hover": { backgroundColor: "#06468c" },
            }}
          >
            Confirm (Accept)
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New POC Dialog */}
      <Dialog
        open={showAddPocForm}
        onClose={() => setShowAddPocForm(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Add New POC (Shift In-Charge)</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            margin="normal"
            value={newPoc.name}
            // onChange={(e) => setNewPoc({ ...newPoc, name: e.target.value })}
            onChange={(e) => {
              const alphabetOnly = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              setNewPoc({ ...newPoc, name: alphabetOnly });
            }}
            placeholder="Enter name"
            InputLabelProps={{
              shrink: true, // Keep label floated always
            }}
            InputProps={{
              notched: false, // Disable notch cutting
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid transparent", // 👈 transparent border to maintain layout
                borderRadius: "8px",
                transition: "border 0.2s ease",
                "&:hover": {
                  border: "1px solid transparent", // ⛔ no gray border on hover
                },
                "&.Mui-focused": {
                  border: "2px solid #1976d2", // ✅ blue border on focus
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  display: "none", // ⛔ completely remove the default fieldset
                },
              },
              "& .MuiInputLabel-root": {
                backgroundColor: "#fff", // Match modal/dialog background
                padding: "0 4px",
                zIndex: 1,
              },
            }}
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={newPoc.email}
            // onChange={(e) => setNewPoc({ ...newPoc, email: e.target.value })}
            onChange={handleEmailChange}
            placeholder="Enter email"
            InputLabelProps={{
              shrink: true, // Keep label floated always
            }}
            InputProps={{
              notched: false, // Disable notch cutting
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid transparent", // 👈 transparent border to maintain layout
                borderRadius: "8px",
                transition: "border 0.2s ease",
                "&:hover": {
                  border: "1px solid transparent", // ⛔ no gray border on hover
                },
                "&.Mui-focused": {
                  border: "2px solid #1976d2", // ✅ blue border on focus
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  display: "none", // ⛔ completely remove the default fieldset
                },
              },
              "& .MuiInputLabel-root": {
                backgroundColor: "#fff", // Match modal/dialog background
                padding: "0 4px",
                zIndex: 1,
              },
            }}
          />
          {emailError && (
            <p style={{ color: "red", fontSize: "0.85rem" }}>{emailError}</p>
          )}
          <TextField
            label="Phone"
            fullWidth
            margin="normal"
            value={newPoc.phone}
            inputProps={{ maxLength: 10 }}
            // onChange={(e) => setNewPoc({ ...newPoc, phone: e.target.value })}
            onChange={(e) => {
              const value = e.target.value;
              // Allow only digits and max 10 characters
              if (/^\d{0,10}$/.test(value)) {
                setNewPoc({ ...newPoc, phone: value });
              }
            }}
            placeholder="Enter phone number"
            InputLabelProps={{
              shrink: true, // Keep label floated always
            }}
            InputProps={{
              notched: false, // Disable notch cutting
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid transparent", // 👈 transparent border to maintain layout
                borderRadius: "8px",
                transition: "border 0.2s ease",
                "&:hover": {
                  border: "1px solid transparent", // ⛔ no gray border on hover
                },
                "&.Mui-focused": {
                  border: "2px solid #1976d2", // ✅ blue border on focus
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  display: "none", // ⛔ completely remove the default fieldset
                },
              },
              "& .MuiInputLabel-root": {
                backgroundColor: "#fff", // Match modal/dialog background
                padding: "0 4px",
                zIndex: 1,
              },
            }}
          />
          {errorMsg && (
            <Typography color="error" variant="body2" mt={1}>
              {errorMsg}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowAddPocForm(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handlePocCreate}
            variant="contained"
            disabled={isSubmitting}
            sx={{ backgroundColor: "#06468c" }}
          >
            {isSubmitting ? "Creating..." : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
